import { Card } from "@/components/ui/card";
import { proxiedImage } from "@/lib/api";

export default function JudgesGrid({ judges }) {
  if (!judges?.length) return null;
  return (
    <section id="judges" data-testid="judges-section" className="bg-emerald-50 py-20 sm:py-24 border-t border-b border-emerald-100">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="max-w-2xl mb-10">
          <div className="text-[11px] uppercase tracking-[0.3em] text-emerald-800 font-[Outfit] font-bold">Meet The Panel</div>
          <h2 className="font-[Cormorant_Garamond] text-4xl sm:text-5xl text-emerald-950 mt-3 leading-tight">
            Our Judges
          </h2>
          <p className="text-slate-700 font-[Outfit] mt-3">
            A panel of operators, mentors and capital-access experts evaluating this year&apos;s pitches.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {judges.map((j) => (
            <Card key={j.id} data-testid={`judge-${j.id}`} className="overflow-hidden bg-white border border-emerald-200 hover:border-emerald-400 transition-colors">
              <div className="aspect-[4/5] bg-emerald-100 relative overflow-hidden flex items-center justify-center">
                <div className="text-emerald-700 font-[Cormorant_Garamond] text-4xl select-none" aria-hidden="true">
                  {j.name?.slice(0, 1) || "?"}
                </div>
                {j.photo_url && (
                  <img
                    src={proxiedImage(j.photo_url)}
                    alt={j.name}
                    loading="lazy"
                    decoding="async"
                    referrerPolicy="no-referrer"
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                )}
              </div>
              <div className="p-5">
                <h3 className="font-[Cormorant_Garamond] text-2xl text-emerald-950">{j.name}</h3>
                <div className="text-sm text-emerald-800 font-[Outfit] mt-1">
                  {[j.title, j.company].filter(Boolean).join(" · ")}
                </div>
                {j.bio && <p className="text-sm text-slate-600 font-[Outfit] mt-3 leading-relaxed line-clamp-4">{j.bio}</p>}
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
